<template>
  <div class="nav">
    <div class="nav-item"
         v-for="(block,index) in items"
         :key='index'>
      <div class="item-header"
           v-bind:class="[typeSelected === index ? 'selected':'']"
           @click="foldItem(index)">
        {{typeName(index)}}
        <svg class="item-arrow"
             v-bind:class="{ 'reverse-arrow': foldList[index]}"
             style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;"
             viewBox="0 0 1024 1024"
             version="1.1"
             xmlns="http://www.w3.org/2000/svg"
             p-id="1459">
          <path d="M478.31207 644.159081C502.692194 671.061286 542.819471 670.698193 566.819471 643.269621L837.388303 334.048098C845.146852 325.181184 844.248346 311.703582 835.381431 303.94503 826.514517 296.186481 813.036915 297.084988 805.278364 305.951902L534.709532 615.173423C527.507586 623.40422 517.168621 623.497773 509.927514 615.507586L229.141056 305.674253C221.229163 296.943889 207.737949 296.280386 199.007586 304.192277 190.277222 312.104171 189.61372 325.595383 197.525612 334.325747L478.31207 644.159081Z"
                p-id="1460"></path>
        </svg>
      </div>

      <ul class="item-list"
          v-bind:class="{ 'fold-items': foldList[index]}">
        <li v-for="item in items[index]"
            :key='item.value'
            class="item-content"
            @click="switchItem(item)">
          <a class="item-a"
             v-bind:class="[itemSelected === item.value && typeSelected === index?'item-content-selected':'']">{{ item.title }}</a>

        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navright',
  props: ['selected', 'items'],
  data() {
    return {
      key: 'value',
      foldList: {
        lgt: false,
        ggt: false
      }
    };
  },
  created: function() {},
  beforeUpdate: function() {
    // let type = this.selected[0]
    // if(this.foldList[type]){
    //   this.foldList[type] = false;
    // }
  },
  methods: {
    switchItem(e) {
      let type = e.type;
      let item = e.value;
      let arr = [type, item];
      console.log(arr);
      this.$emit('update:selected', arr);
      this.$nextTick(() => {
        this.goAnchor(type, item);
      });

      if (type === 'lgt') {
        if (item === 'sctj') {
          TA.log({ id: 'cgpz_lgt_sctj_10', _sid: 'cgpz_lgt_sctj_10' });
        }
        if (item === 'zstj') {
          TA.log({ id: 'cgpz_lgt_zstj_10', _sid: 'cgpz_lgt_zstj_10' });
        }
        if (item === 'hytj') {
          TA.log({ id: 'cgpz_lgt_hytj_10', _sid: 'cgpz_lgt_hytj_10' });
        }
        if (item === 'zcgtj') {
          TA.log({ id: 'cgpz_lgt_zctj_10', _sid: 'cgpz_lgt_zctj_10' });
        }
      } else {
        if (item === 'sctj') {
          TA.log({ id: 'cgpz_ggt_sctj_10', _sid: 'cgpz_ggt_sctj_10' });
        }
        if (item === 'zstj') {
          TA.log({ id: 'cgpz_ggt_zstj_10', _sid: 'cgpz_ggt_zstj_10' });
        }
        if (item === 'hytj') {
          TA.log({ id: 'cgpz_ggt_hytj_10', _sid: 'cgpz_ggt_hytj_10' });
        }
        if (item === 'zcgtj') {
          TA.log({ id: 'cgpz_ggt_zctj_10', _sid: 'cgpz_ggt_zctj_10' });
        }
      }
    },
    goAnchor(type, item) {
      var targetName = 'anchor-' + type + item;
      let checkTarget = document.getElementById('anchor-lgtzstj');
      let target = document.getElementById(targetName);
      let main = document.getElementById('hodeconfMain');
      let p = target.offsetTop;
      if ((item == 'zstj' && checkTarget.offsetTop <= 50) || item == 'sctj') {
        p = p - 40;
      }
      main.scrollTop = p;
    },
    foldItem(type) {
      this.foldList[type] = !this.foldList[type];
    },
    typeName(type) {
      if (type === 'lgt') {
        return '陆股通';
      } else {
        return '港股通';
      }
    }
  },
  computed: {
    typeSelected() {
      return this.selected[0];
    },
    itemSelected() {
      return this.selected[1];
    }
  }
};
</script>

<style scoped>
.nav-item {
  position: relative;
  cursor: pointer;
}
.item-header {
  width: 115px;
  height: 32px;
  /* background-color: #0b1016; */
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 33px;
  letter-spacing: 0px;
  /* color: #ffffff; */
  padding-left: 13px;
  /* border-left: 3px solid #0b1016; */
  /* border-bottom: 1px solid #000; */
}
.item-list {
  transition: all 0.7s;
  transition-timing-function: ease;
  max-height: 140px;
  overflow: hidden;
}
.fold-items {
  max-height: 0;
}
.item-content {
  width: 115px;
  height: 32px;
  /* background-color: #0b1016; */
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0px;
  /* color: #bbbbbb; */
  /* padding-left: 28px; */
  text-align: center;
  line-height: 32px;
  /* border-bottom: 1px solid #000; */
}
.item-a {
  display: block;
  width: 115px;
  text-align: left;
  padding-left: 20px;
  height: 32px;
  /* color: #bbbbbb; */
  text-decoration: none;
}
.item-content-selected {
  color: #088ec6;
  /* border-left: 3px solid #088ec6; */
}
.item-a:hover {
  color: #088ec6;
}
/* .selected {
  border-left: 3px solid #b40606;
  background-color: #31373c;
} */
.item-arrow {
  width: 10px;
  height: 6px;
  top: 10px;
  right: 7px;
  position: absolute;
  transition: all 1s;
  transition-timing-function: ease;
}
</style>


// WEBPACK FOOTER //
// src/components/nav.vue